module.exports = __webpack_public_path__ + "img/MEDIA037.84639997.jpg";